import { Route, Routes } from "react-router-dom"
import NotFound404 from "../pages/NotFound404"
import RequireAuth from "../components/Authentication/RequireAuth";
import PersistLogin from "../components/Authentication/PersistLogin";
import NewRequest from "../pages/NewRequest";
import ViewRequest from "../pages/ViewRequest";
import MyRequestListPage from "../pages/MyRequestListPage";
import WhichRequestViewPage from "../pages/WhichRequestViewPage";
import WhichRequestViewByApproverPage from "../pages/WhichRequestViewByApproverPage";
import WhichRequestViewForCommentsPage from "../pages/WhichRequestViewForCommentsPage";
import ReadCommentPage from "../pages/ReadCommentPage";

const RequestRouter = () => {
    return (
            <Routes>
                <Route element={<PersistLogin />}>
                    <Route element={<RequireAuth allowedRoles={["100"]} />}>
                        <Route path="/" element={<MyRequestListPage />} />
                        <Route path="/read-comment" element={<ReadCommentPage />} />
                        <Route path="/which-request-view-for-comments" element={<WhichRequestViewForCommentsPage />} />
                        <Route path="/which-request-view-as-approver" element={<WhichRequestViewByApproverPage />} />
                        <Route path="/which-request-view" element={<WhichRequestViewPage />} />
                        <Route path="/request-details" element={<NewRequest />} />
                        <Route path="/view-request-details" element={<ViewRequest />} />
                        <Route path="*" element={<NotFound404 />} />
                    </Route>
                </Route>
            </Routes>            
    )
}

export default RequestRouter;